import perm from "./permission"

const install = function(Vue) {
  Vue.directive("perm", perm)
}

if (window.Vue) {
  window["perm"] = perm
  Vue.use(install) // eslint-disable-line
}

perm.install = install
export default perm
